var map = {
	"./accenture.png": 32902,
	"./adga.png": 24874,
	"./agilebits.png": 8640,
	"./balsamiq.png": 83053,
	"./bitesite.png": 67337,
	"./bloomberg.png": 25655,
	"./boc.png": 13052,
	"./bridgehead.png": 96553,
	"./canada.png": 46394,
	"./cdw.png": 75522,
	"./cengen.png": 66161,
	"./ciena.png": 74781,
	"./cse.png": 62572,
	"./cseNew.png": 60765,
	"./deloitte.png": 32384,
	"./drdc1.png": 15043,
	"./electronicarts.png": 32309,
	"./fitbit.png": 77263,
	"./github-emblem.png": 41874,
	"./github-logo.png": 91868,
	"./google.png": 66394,
	"./hub350.png": 67683,
	"./innovapost.png": 75155,
	"./kanatanorthbia.png": 50888,
	"./kinaxis.png": 48037,
	"./klipfolio.png": 52106,
	"./legacy.png": 11565,
	"./lspark.png": 69172,
	"./marchnetworks.png": 46968,
	"./microsoft.png": 10171,
	"./mlh-logo-color.png": 76327,
	"./mnp.png": 49978,
	"./momentive.png": 65287,
	"./morganstanley.png": 72851,
	"./neo.png": 83000,
	"./noibu.png": 13752,
	"./nokia.png": 66897,
	"./phreesia.png": 69665,
	"./rc.jpg": 22067,
	"./rl.png": 56206,
	"./scalar.png": 72190,
	"./solace.png": 47462,
	"./splunk.png": 62221,
	"./sunlife.png": 84415,
	"./surveymonkey.png": 3183,
	"./trendmicro.png": 1293,
	"./twilio.png": 96916,
	"./twillio.png": 53422,
	"./uoLogo.png": 99812,
	"./wolfram.png": 77805,
	"./youi.png": 90721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50309;